export const sortOrderCodeForQueries = (sort: 1 | -1 | 0) => (sort === 1 ? 'ASC' : 'DESC');
